import React from 'react';
import { useSelector } from 'react-redux';
import '../common.css';

// InputTitle is a reusable component for rendering titles.
// It accepts 'title',  'className' and 'isRequired' as props.
const InputTitle = ({ title, className = null, isRequired=false }) => {
    // Get theme-related information from the Redux store using 'useSelector'.
    const { inputLabelColor, themeTemplate, inputError } = useSelector((state) => state.theme);

    // Define a default class name for your component based on 'themeTemplate'.
    const defaultClassName =
        themeTemplate === '103' ||
        themeTemplate === '106' ||
        themeTemplate === '105'
            ? 'custom-input-title2'
            : themeTemplate === '109'
            ? 'custom-input-title3'
            : 'custom-input-title';

    // Combine the default class name with the custom class name (if provided).
    // If 'className' is provided, the custom class is added to the default class.
    const combinedClassName = className
        ? `${defaultClassName} ${className}`
        : defaultClassName;

    // Render a <div> element with the combined class name and label color.
    return (
        <div
            className={combinedClassName}
            style={{ color: inputLabelColor }}
        >
            {/* Use dangerouslySetInnerHTML to render the HTML content in the title prop */}
            <span dangerouslySetInnerHTML={{ __html: title }} />
            {isRequired && <span style={{ color: inputError, fontSize: "14px" }}>*</span>}
        </div>
    );
};

// Export the InputTitle component for use in other parts of your application.
export default InputTitle;
